import { Card, ExternalLink, Icon, Text, TextLink } from '@ui/themed';
import { t } from 'i18next';
import { useState } from 'react';

export function PlanPoint(props: { title: string; description?: string; exploreMoreURL?: string }) {
  const [showDescription, setShowDescription] = useState<boolean>(false);

  return (
    <div className="flex flex-col gap-1">
      <div className="flex flex-row items-center gap-1 align-middle">
        <Icon name="checkCircle" />
        <div className="flex-1 grow">
          <Text variant="secondary">{props.title}</Text>
        </div>
        <div className="flex shrink flex-col items-center align-middle">
          <TextLink onClick={() => setShowDescription(!showDescription)}>
            <Icon name="infoCircle" />
          </TextLink>
        </div>
      </div>
      {showDescription && (
        <Card variant="secondary" size="sm">
          <Text variant="secondary" size="sm">
            {props.description}
            {props.exploreMoreURL && (
              <>
                {' '}
                <ExternalLink link={props.exploreMoreURL} showIcon>
                  {t('links:explore_more')}
                </ExternalLink>
              </>
            )}
          </Text>
        </Card>
      )}
    </div>
  );
}
